<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0 d-md-flex">
				<div class="col-12 col-md-8 pl-0 pr-0 pr-md-3">
					<div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow">
						<div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterReport"
							@click="toggleFilter" :class="tfilter == true ? 'active' : ''">
							<div class="col-6 pl-0 mt-auto mb-auto">
								<div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
							</div>
						</div>
						<div id="filterReport" class="collapse">
							<div class="col-12 pb-3 pl-2 pr-2 font-size-10">
								<div class="col-12 pl-0 pr-0 d-flex">
									<div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Tanggal</div>
									<div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
										<div class="col-6 pl-0 pr-2">
											<datetime input-id="tanggalAwal" :max-datetime="maxDate"
												:min-datetime="new Date('2000-01-01').toISOString()" class="theme-purple"
												input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
												placeholder="Dari Tanggal" v-model="tanggalAwal"></datetime>
										</div>
										<div class="col-6 pl-0 pr-0">
											<datetime input-id="tanggalAkhir" :max-datetime="today" :min-datetime="minDate" class="theme-purple"
												input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
												placeholder="Sampai Tanggal" v-model="tanggalAkhir"></datetime>
										</div>
									</div>
								</div>
								<div class="col-12 pl-0 pr-0 pt-2 d-flex">
									<div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kode Transaksi</div>
									<div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
										<input v-model="kode.value"
											class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
											placeholder="Kode Transaksi">
									</div>
								</div>
								<div class="col-12 pl-0 pr-0 pt-2 d-flex flex-wrap">
									<div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kategori Transaksi</div>
									<div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
										<select class="form-control form-control-sm font-size-9 box-purple text-gray rounded-cus"
											v-model="member.value">
											<option v-for="filter in memberStatus" :key="filter.value" :value="filter.value">{{ filter.name }}
											</option>
										</select>
									</div>
									<div class="col-5 d-lg-none"></div>
									<div class="col-12 col-md-7 col-lg-4 d-flex pl-0 pl-lg-3 pr-0 pr-lg-3 pt-3 pt-lg-0">
										<div class="col-6 pl-0 pr-2 pr-md-3">
											<button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span
													class="font-size-9">Reset</span></button>
										</div>
										<div class="col-6 pl-0 pr-0 pr-md-2 pr-lg-3">
											<button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span
													class="font-size-9">Cari</span></button>
										</div>
									</div>
								</div>
								<!-- <div class="col-12 pl-0 pr-0 pt-2 d-flex flex-wrap">
									<div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Tipe Transaksi</div>
									<div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
										<select class="form-control form-control-sm font-size-9 box-purple text-gray rounded-cus" v-model="tipe.value">
											<option v-for="filter in tipeStatus" :key="filter.value" :value="filter.value">{{ filter.name }}</option>
										</select>
									</div>
									<div class="col-5 d-lg-none"></div>
									<div class="col-12 col-md-7 col-lg-4 d-flex pl-0 pl-lg-3 pr-0 pr-lg-3 pt-3 pt-lg-0">
										<div class="col-6 pl-0 pr-2 pr-md-3">
											<button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span class="font-size-9">Reset</span></button>
										</div>
										<div class="col-6 pl-0 pr-0 pr-md-2 pr-lg-3">
											<button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span class="font-size-9">Cari</span></button>
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
					<div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
						<div class="col-12 pt-3 pb-3 pl-2 pr-2 d-flex">
							<div class="col-8 col-md-6 pl-0 pb-1 mt-auto mb-auto">
								<div class="col-12 pl-0 pr-0 font-size-sm-11">Laporan Penjualan</div>
							</div>
							<!-- <div class="col-4 col-md-6 pr-0">
								<div class="col-12 pl-0 pr-0 text-right">
									<div class="btn-group">
										<button type="button" class="btn bg-white rounded-pill box-blue" data-toggle="dropdown">
											<div class="pl-1 pr-1 color-gray-2 font-size-12"><i class="fas fa-ellipsis-v"></i></div>
										</button>
										<div class="dropdown-menu dropdown-menu-right dropdown-mila">
											<button class="dropdown-item" type="button"><span class="font-size-9" @click="filter(0)">Tampilkan semua penjualan</span></button>
											<button class="dropdown-item" type="button"><span class="font-size-9" @click="filter(1)">Tampilkan penjualan langsung</span></button>
											<button class="dropdown-item" type="button"><span class="font-size-9" @click="filter(2)">Tampilkan penjualan mitra baru</span></button>
										</div>
									</div>
								</div>
							</div> -->
						</div>
						<div class="col-12 pl-0 pr-0 overflow-auto">
							<div class="col-12 mt-3 pl-2 pr-2 pb-3 d-flex flex-lg-wrap font-size-10">
								<div class="col-8 col-md-6 col-lg-4 pl-0">Detail</div>
								<div class="col-6 col-md-4 pl-0">Kategori</div>
								<div class="col-8 col-md-6 col-lg-4 pl-0 d-flex">
									<div class="col-9 pl-0 text-right">Total Transaksi</div>
									<!-- <div class="col-3 pr-0 text-right">
										<div class="col-12 pr-0"><img class="cursor-pointer" src="/assets/report/icon-export-excel.svg"></div>
									</div> -->
								</div>
							</div>
							<div class="col-12 pl-2 pr-2">
								<div class="col-12 border-bottom d-none d-lg-block"></div>
							</div>
							<div v-show="dataPenjualan.length == 0">
								<div class="col-12 pt-3 pl-2 pr-2" v-for="(index) in 4" :key="index">
									<vcl :width='300' :height='50' class="border-bottom">
										<rect x="1" y="2" rx="2" ry="2" width="30" height="7" />
										<rect x="1" y="15" rx="2" ry="2" width="60" height="7" />
										<rect x="1" y="25" rx="2" ry="2" width="28" height="7" />
										<rect x="1" y="35" rx="2" ry="2" width="35" height="7" />
										<rect x="100" y="18" rx="5" ry="5" width="7" height="7" />
										<rect x="110" y="18" rx="2" ry="2" width="28" height="7" />
										<rect x="230" y="18" rx="2" ry="2" width="35" height="7" />
										<rect x="284" y="19" rx="1" ry="1" width="9" height="9" />
										<rect x="284" y="3" rx="5" ry="5" width="9" height="9" />
									</vcl>
								</div>
							</div>
							<div class="col-12 pl-0 pr-0" v-if="dataPenjualan == 'error'">
								<div class="col-12 pt-3 pb-3 text-center">
									<div class="col-6 col-md-4 ml-auto mr-auto">
										<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
									</div>
									<div class="font-size-11 pt-1">Data tidak tersedia!</div>
								</div>
							</div>
							<div class="col-12 pl-0 pr-0" v-else>
								<div class="col-12 pt-3 pl-2 pr-2 pb-3 d-flex flex-lg-wrap font-size-10" v-for="(value, index) in dataPenjualan"
									:key="index">
									<div class="col-8 col-md-6 col-lg-4 pl-0">
										<div class="col-12 pl-0">Kode Transaksi {{ value.trx_code }}</div>
										<div class="col-12 pl-0 color-gray-2 pt-2 font-size-9">{{ value.trx_datetime | tanggaljam }}</div>
										<div v-if="value.trx_member_status == 'member'">
											<div class="col-12 pl-0 pt-1">{{ value.trx_buyer_name }}</div>
											<div class="col-12 pl-0 color-gray-2 pt-1 font-size-9">{{ value.trx_buyer_mobilephone }}</div>
										</div>
										<div v-if="value.trx_member_status == 'nonmember'">
											<div class="col-12 pl-0 pt-1">{{ value.trx_prospective_member_name }}</div>
											<div class="col-12 pl-0 color-gray-2 pt-1 font-size-9">{{ value.trx_prospective_member_mobilephone }}</div>
										</div>
									</div>
									<div class="col-6 col-md-4 pl-0 m-auto">
										<span :class="[value.trx_member_status == 'nonmember' ? 'color-light-blue' : 'color-purple']"><i
												class="fas fa-circle"></i></span>
										<span class="pl-2">{{ value.trx_member_status == 'nonmember' ? 'Calon Mitra' : 'Mitra' }}</span>
									</div>
									<div class="col-8 col-md-6 col-lg-4 pl-0 d-flex">
										<div class="col-9 mt-auto mb-auto text-right">{{ value.trx_price_grand_total | toRupiah }}</div>
										<div class="col-3 pr-0 text-right">
											<div class="col-12 pr-0"><img @click="detailReport(value.trx_id)" class="cursor-pointer"
													src="/assets/report/icon-details.svg"></div>
											<div class="col-12 pr-0 pt-3"><a target="_blank" :href="value.download_pdf"><img
														class="cursor-pointer" src="/assets/report/icon-print-bill.svg"></a></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pl-2 pr-2">
							<div class="col-12 border-bottom"></div>
						</div>
						<div class="col-12 pt-3 pl-2 pr-2 text-center">
							<i-pagination :limit='limit' @changeLimit="changeLimit($event)" :pagination='pagination' @gotoPage="gotoPage($event)"
								@refresh="refresh($event)"></i-pagination>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-4 pl-0 pr-0 pt-3 pt-md-0">
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow" v-if="productSelling == 'error'">
						<div class="col-12 pt-3 pl-2 pr-2 d-flex">
							<div class="col-12 pl-0 mt-auto mb-auto">Produk Terjual</div>
						</div>
						<div class="col-12 pb-2 pl-2 pr-2 d-flex" v-if="rangeLaporan == ''">
							<div class="col-12 pl-0 mt-auto mb-auto"></div>
						</div>
						<div class="col-12 pb-2 pl-2 pr-2 d-flex" v-else>
							<div class="col-12 pl-0 mt-auto mb-auto">{{ rangeLaporan }}</div>
						</div>
						<div class="col-12 pt-3 pb-3 text-center">
							<div class="col-6 ml-auto mr-auto">
								<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
							</div>
							<div class="font-size-11 pt-1">Data tidak tersedia!</div>
						</div>
					</div>
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow" v-else>
						<div class="col-12 pt-3 pl-2 pr-2 d-flex">
							<div class="col-12 pl-0 mt-auto mb-auto">Produk Terjual</div>
						</div>
						<div class="col-12 pb-2 pl-2 pr-2 d-flex" v-if="rangeLaporan">
							<div class="col-12 pl-0 mt-auto mb-auto">{{ rangeLaporan }}</div>
						</div>
						<div class="col-12 pb-2 pl-2 pr-2 d-flex" v-else>
							<div class="col-12 pl-0 mt-auto mb-auto"></div>
						</div>
						<div class="col-12 pl-0 pr-0" v-show="buyerChartData.length == 1">
							<vcl :width='300' :height='230'>
								<circle cx="150" cy="110" r="90" />
							</vcl>
						</div>
						<div class="col-12 pl-0 pr-0" v-if="buyerChartData.length > 1">
							<div class="col-12 pl-2 pr-2">
								<r-chart :chartData='buyerChartData'></r-chart>
							</div>
						</div>
					</div>
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow mt-3" v-if="rincianLaporan == 'error'">
						<div class="col-12 pt-3 pl-2 pr-2 d-flex">
							<div class="col-12 pl-0 mt-auto mb-auto">Rincian Laporan</div>
						</div>
						<div class="col-12 pt-3 pb-3 text-center">
							<div class="col-6 ml-auto mr-auto">
								<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
							</div>
							<div class="font-size-11 pt-1">Data tidak tersedia!</div>
						</div>
					</div>
					<div class="col-12 pb-3 bg-white rounded-cus cus-box-shadow mt-3" v-else>
						<div class="col-12 pt-3 pl-2 pr-2 d-flex">
							<div class="col-12 pl-0 mt-auto mb-auto">Rincian Laporan</div>
						</div>
						<div class="col-12 pl-2 pr-2" v-show="rincianLaporan.length == 0">
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-total-penjualan.svg"></div>
								<div class="col-9 pl-2 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Total Penjualan (Rp)</div>
									<vcl :width='300' :height='60'>
										<rect x="1" y="12" rx="3" ry="3" width="130" height="30" />
									</vcl>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-total-produk-terjual.svg"></div>
								<div class="col-9 pl-2 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Total Produk Terjual</div>
									<vcl :width='300' :height='60'>
										<rect x="1" y="12" rx="3" ry="3" width="30" height="30" />
									</vcl>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-tambahan-mitra-baru.svg"></div>
								<div class="col-9 pl-2 pr-0 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Tambahan Mitra Baru</div>
									<vcl :width='300' :height='60'>
										<rect x="1" y="12" rx="3" ry="3" width="20" height="30" />
									</vcl>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
						</div>
						<div class="col-12 pl-2 pr-2" v-if="rincianLaporan">
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-total-penjualan.svg"></div>
								<div class="col-9 pl-2 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Total Penjualan (Rp)</div>
									<div class="col-12 pl-0 font-size-13 pt-1">{{ rincianLaporan.total_selling | toNumber }}</div>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-total-produk-terjual.svg"></div>
								<div class="col-9 pl-2 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Total Produk Terjual</div>
									<div class="col-12 pl-0 font-size-13 pt-1">{{ rincianLaporan.total_product | toNumber }}</div>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
							<div class="col-12 pl-0 pr-0 pt-4 d-flex flex-wrap">
								<div class="col-3 pl-0"><img class="img-fluid" src="/assets/report/icon-tambahan-mitra-baru.svg"></div>
								<div class="col-9 pl-2 mt-auto mb-auto">
									<div class="col-12 pl-0 color-gray-2 font-size-9">Tambahan Mitra Baru</div>
									<div class="col-12 pl-0 font-size-13 pt-1">{{ rincianLaporan.total_member | toNumber }}</div>
								</div>
								<div class="col-12 pt-4 border-bottom"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalDetail">
			<template v-slot:header>
				<div class="modal-title font-size-12 font-weight-bold" v-show="Object.values(detailPenjualan).length == 0">
					<vcl :width='300' :height='20'>
						<rect x="6" y="8" rx="3" ry="3" width="70" height="10" />
						<rect x="285" y="7" rx="3" ry="3" width="9" height="9" />
					</vcl>
				</div>
				<div class="modal-header no-border p-3" v-if="Object.values(detailPenjualan).length > 0">
					<div class="modal-title font-size-12 font-size-sm-10 font-weight-bold">Detail Transaksi {{ detailPenjualan.trx_code }} a/n
						{{ detailPenjualan.trx_buyer_name }}</div>
					<button class="btn no-box-focus"><span @click="hideDetailReport" class="close-modal ml-2 color-red"><i
								class="fas fa-times"></i></span></button>
				</div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 pb-4 pt-2 pl-0 pr-0 pl-md-3 pr-md-3" v-show="Object.values(detailPenjualan).length == 0">
					<vcl :width='300' :height='110' class="col-12 pl-0 pr-0 d-flex flex-wrap">
						<rect x="1" y="0" rx="5" ry="5" width="9" height="9" />
						<rect x="13" y="0" rx="3" ry="3" width="30" height="10" />
						<rect x="97" y="0" rx="9" ry="3" width="88" height="14" />
						<rect x="210" y="0" rx="9" ry="3" width="88" height="14" />
						<rect x="1" y="18" rx="5" ry="5" width="9" height="9" />
						<rect x="13" y="18" rx="3" ry="3" width="50" height="10" />
						<rect x="97" y="16" rx="3" ry="3" width="85" height="12" />
						<rect x="210" y="16" rx="3" ry="3" width="85" height="12" />
						<rect x="13" y="32" rx="3" ry="3" width="60" height="10" />
						<rect x="97" y="31" rx="3" ry="3" width="85" height="12" />
						<rect x="210" y="31" rx="3" ry="3" width="85" height="12" />
						<rect x="5" y="57" rx="7" ry="7" width="50" height="50" />
						<rect x="97" y="60" rx="3" ry="3" width="65" height="11" />
						<rect x="190" y="60" rx="3" ry="3" width="28" height="11" />
						<rect x="232" y="60" rx="3" ry="3" width="10" height="11" />
						<rect x="267" y="60" rx="3" ry="3" width="28" height="11" />
						<rect x="97" y="75" rx="3" ry="3" width="66" height="11" />
						<rect x="185" y="75" rx="3" ry="3" width="33" height="11" />
						<rect x="232" y="75" rx="3" ry="3" width="10" height="11" />
						<rect x="263" y="75" rx="3" ry="3" width="32" height="11" />
						<rect x="97" y="95" rx="3" ry="3" width="52" height="11" />
						<rect x="255" y="95" rx="3" ry="3" width="40" height="11" />
					</vcl>
				</div>
				<div class="col-12 font-size-11 pb-4 pt-2 pl-0 pr-0 pl-md-3 pr-md-3" v-if="Object.values(detailPenjualan).length > 0">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap">
						<div class="col-12 col-md-4 pl-0">
							<div class="col-12 pl-0">
								<span :class="[detailPenjualan.trx_member_status == 'nonmember' ? 'color-light-blue' : 'color-purple']"><i
										class="fas fa-circle w-1rem"></i></span>
								<span class="pl-2">{{ detailPenjualan.trx_member_status == 'nonmember' ? 'Calon Mitra' : 'Mitra' }}</span>
							</div>
							<div class="col-12 pl-0 pt-3 pt-md-4 font-size-10" v-if="detailPenjualan.trx_member_status == 'member'">
								<div class="col-12 pl-0 pr-0"><i class="fas fa-user color-purple w-1rem"></i><span class="pl-2">{{
									detailPenjualan.trx_buyer_name }}</span></div>
								<div class="col-12 pl-4 color-gray-2 pt-1 font-size-9">{{ detailPenjualan.trx_datetime | tanggaljam }}</div>
								<div class="col-12 pl-4 color-gray-2 pt-1 font-size-9">{{ detailPenjualan.trx_buyer_mobilephone }}</div>
							</div>
							<div class="col-12 pl-0 pt-3 pt-md-4 font-size-10" v-if="detailPenjualan.trx_member_status == 'nonmember'">
								<div class="col-12 pl-0 pr-0"><i class="fas fa-user color-light-blue w-1rem"></i><span class="pl-2">{{
									detailPenjualan.trx_prospective_member_name }}</span></div>
								<div class="col-12 pl-4 color-gray-2 pt-1 font-size-9">{{ detailPenjualan.trx_datetime | tanggaljam }}</div>
								<div class="col-12 pl-4 color-gray-2 pt-1 font-size-9">{{ detailPenjualan.trx_prospective_member_mobilephone }}</div>
							</div>
						</div>
						<div class="col-12 col-md-8 pl-0 d-flex flex-wrap">
							<div class="col-6 col-md-6 pl-0 pb-2 pb-md-3 pt-3 pt-md-0"
								v-for="(product, index) in detailPenjualan.product.filter(el => el.product_is_serial > 0)" :key="index">
								<div class="col-12 label-detail-product">{{ product.product_code }} Terjual ({{ product.product_quantity }})
								</div>
								<div class="col-12 mt-1 code-detail-product" v-for="(serial, index) in product.product_serial" :key="index">
									{{ serial }}</div>
							</div>
							<div class="col-6 col-md-6 pl-0 pb-2 pb-md-3 pt-3 pt-md-0" v-if="detailPenjualan.trx_is_register > 0">
								<div class="col-12 label-detail-product">Serial Registrasi ({{ detailPenjualan.registrasi_item.code }})</div>
								<div class="col-12 mt-1 code-detail-product">{{ detailPenjualan.registrasi_item.serial_used }}</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 d-flex pt-3">
						<div class="col-4 pl-0 d-none d-md-block">
							<img class="img-fluid" src="/assets/report/icon-shopping.svg">
						</div>
						<div class="col-12 col-md-8 pl-0 pr-0 font-size-10">
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-for="(product, index) in detailPenjualan.product" :key="index">
								<div class="col-12 col-md-5 pl-0 pb-1" :class="(detailPenjualan.trx_price_shipping == 0) ? 'pb-md-3' : ''">{{ product.product_name }}</div>
								<div class="col-5 col-md-2 pl-md-0 pr-0 text-md-right color-gray-2">@{{ product.product_price | toNumber }}</div>
								<div class="col-3 col-md-2 pl-0 text-right color-gray-2">{{ product.product_quantity }}</div>
								<div class="col-4 col-md-3 pl-0 text-right color-gray-2">{{ (product.product_sub_total) | toNumber }}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailPenjualan.trx_is_register > 0">
								<div class="col-12 col-md-5 pl-0 pb-1 pb-md-3">{{ detailPenjualan.registrasi_item.title }}</div>
								<div class="col-5 col-md-2 pl-md-0 pr-0 text-md-right color-gray-2">@{{ detailPenjualan.registrasi_item.price |
									toNumber }}</div>
								<div class="col-3 col-md-2 pl-0 text-right color-gray-2">{{ detailPenjualan.registrasi_item.quantity }}</div>
								<div class="col-4 col-md-3 pl-0 text-right color-gray-2">{{ (detailPenjualan.registrasi_item.price_total) |
									toNumber }}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pb-md-3" v-if="detailPenjualan.trx_price_shipping > 0">
								<div class="col-6 pl-0 color-gray-2">Tambahan Ongkos Kirim</div>
								<div class="col-6 pl-0 color-gray-2 text-right">{{ detailPenjualan.trx_price_shipping | toNumber }}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0">
								<div class="col-6 pl-0 font-weight-bold">Total Transaksi</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{ detailPenjualan.trx_price_grand_total | toRupiah }}</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal"></div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import RChart from '@/components/chart/RChart.vue';
import IPagination from '@/components/IPagination.vue';
import IModal from '@/components/IModal.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment'

export default {
	components: {
		RChart,
		IModal, IPagination
	},
	name: 'Report',
	data() {
		return {
			tipeStatus: [{ value: '', name: 'Pilih Tipe' }, { value: '1', name: 'Mitra' }, { value: '2', name: 'Mitra Baru' }],
			memberStatus: [{ value: '', name: 'Pilih Kategori Transaksi' }, { value: 'member', name: 'Mitra' }, { value: 'nonmember', name: 'Calon Mitra' }],
			tanggalAwal: "",
			tanggalAkhir: "",
			tfilter: false,
			today: new Date().toISOString(),
			limit: 4,
			tanggal: {
				value: '',
				comparison: 'bet',
				type: 'date',
				field: 'trx_datetime'
			},
			kode: {
				value: '',
				comparison: 'LIKE',
				type: 'string',
				field: 'trx_code'
			},
			tipe: {
				value: '',
				comparison: '=',
				type: 'numeric',
				field: 'is_register'
			},
			member: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'trx_member_status'
			},
			params: {},
			rangeLaporan: '',
			page: 1
		}
	},
	methods: {
		gotoPage(val) {
			this.page = val
			if (this.params) {
				this.getLaporanPenjualan({ params: this.params, page: this.page, limit: this.limit })
			} else {
				this.getLaporanPenjualan({ page: this.page, limit: this.limit })
			}
		},
		refresh(val) {
			this.page = val
			if (this.params) {
				this.getLaporanPenjualan({ params: this.params, page: this.page, limit: this.limit })
			} else {
				this.getLaporanPenjualan({ page: this.page, limit: this.limit })
			}
		},
		changeLimit(val) {
			this.page = 1
			this.limit = val
			if (this.params) {
				this.getLaporanPenjualan({ params: this.params, page: this.page, limit: this.limit })
			} else {
				this.getLaporanPenjualan({ page: this.page, limit: this.limit })
			}
		},
		detailReport(val) {
			this.getDetailPenjualan({ 'trx_id': val })
			this.$refs.modalDetail.modalShow()
		},
		hideDetailReport() {
			this.$refs.modalDetail.modalHide()
		},
		cari() {
			this.params = []
			this.page = 1
			if (!this.tanggalAkhir) {
				this.tanggalAkhir = this.tanggalAwal
			}
			if (this.tanggalAkhir == this.tanggalAwal) {
				this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
			} else {
				this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
			}
			if (this.tanggalAwal && this.tanggalAkhir) {
				this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggal)
			} else {
				this.rangeLaporan = ''
			}
			if (this.kode.value) {
				this.params.push(this.kode)
			}
			if (this.tipe.value) {
				this.params.push(this.tipe)
			}
			if (this.member.value) {
				this.params.push(this.member)
			}
			this.getLaporanPenjualan({ params: this.params, page: this.page, limit: this.limit })
		},
		reset() {
			this.kode.value = ''
			this.tipe.value = ''
			this.member.value = ''
			this.tanggal.value = ''
			this.rangeLaporan = ''
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.page = 1
			this.getLaporanPenjualan({ params: [], page: this.page, limit: this.limit })
		},
		toggleFilter() {
			if (!this.tfilter) {
				this.tfilter = true;
			} else {
				this.tfilter = false;
			}
		},
		...mapActions('reportList', ['getLaporanPenjualan', 'getDetailPenjualan', 'getRincianLaporan', 'getProductSelling']),
	},
	computed: {
		...mapState('reportList', ['dataPenjualan', 'detailPenjualan', 'rincianLaporan', 'productSelling', 'pagination']),
		...mapGetters('reportList', ['buyerChartData']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),

		minDate() {
			var date = new Date().toISOString()
			if (this.tanggalAwal) {
				date = new Date(this.tanggalAwal).toISOString()
			} else {
				date = new Date("2000-01-01").toISOString()
			}
			return date
		},
		maxDate() {
			var date = new Date().toISOString()
			if (this.tanggalAkhir) {
				date = new Date(this.tanggalAkhir).toISOString()
			}
			return date
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Laporan Penjualan');
		this.getLaporanPenjualan({ params: [], page: this.page, limit: this.limit })
	}
};
</script>
